<template>
  <page>
    <div slot="head" class="page-head-default" :style="{ 'padding-top': safeArea.top + 'px' }">
      <!-- 对齐 App：白底页面用黑色返回箭头 + 顶部 logo（logo_title.png 126.w） -->
      <img src="../../assets/imgs/icon_back.png" alt="" @click="onBack" />
      <img class="head_logo" src="../../assets/imgs/logo_title.png" alt="" />
    </div>
    <!-- 对齐 App login_email：标题 + itemColor 填充输入框 + 主题色 Sign in 按钮 + 第三方登录 -->
    <div class="login-email-warp">
      <div class="page-title">{{ i18n.login_with_email }}</div>
      <div class="login-row">
        <input
          type="email"
          v-model="email"
          :placeholder="i18n.enter_your_email"
        />
      </div>
      <div class="login-spacer"></div>
      <div class="btn" @click="onSendMailCode">{{ i18n.login_submit }}</div>
      <!-- 对齐 App：第三方登录分割线 + Apple/Google 图标 -->
      <div class="login-foot">
        <div class="login-foot-tips">
          <span>{{ i18n.sign_in_with }}</span>
        </div>
        <div class="login-foot-imgs">
          <!-- 隐藏 Apple 登录入口（代码保留，需要时恢复） -->
          <!-- <login-apple @success="loadUser">
            <img src="../../assets/imgs/icon_apple_login.png" alt="" />
          </login-apple> -->
          <login-google @success="loadUser"></login-google>
        </div>
        <div class="login-foot-gap"></div>
      </div>
    </div>
    <login-code
      v-if="isLoginCode"
      :title="i18n.email_code_title"
      :tips="i18n.email_verify_code"
      @submit="onLogin"
      @again="onAgain"
      @back="onBackCode"
    ></login-code>
  </page>
</template>

<script>
import { SEND_MAIL_CODE, LOGIN_EMAIL, USER_INFO } from "../../apis/user"
import { generateMD5 } from "../../utils/md5"
import { LoginCode, LoginGoogle } from "../../components/login"
import { mapState } from "vuex"
export default {
  components: {
    LoginCode,
    LoginGoogle
  },
  computed: {
    ...mapState(["user", "safeArea"]),
    i18n() {
      return this.$t("login")
    }
  },
  watch: {
    user(val, oldVal) {
      if (val && !oldVal) {
        this.$router.push("/")
      }
    }
  },
  data() {
    return {
      email: "",
      isLoginCode: false
    }
  },
  methods: {
    onBack() {
      this.$router.push("/login")
    },
    // 对齐 App generate_MD5：md5(timestamp.replace(0→8) + "GZzbjkj") hex
    generateSign(timestamp) {
      return generateMD5(String(timestamp).split("0").join("8") + "GZzbjkj")
    },
    onSendMailCode() {
      if (this.email === "") {
        this.$toast(this.i18n.enter_your_email)
        return
      }
      this.$loading(true)
      const timestamp = Math.floor(Date.now() / 1000)
      this.$get(
        SEND_MAIL_CODE,
        {
          email: this.email,
          timestamp: timestamp,
          sign: this.generateSign(timestamp)
        },
        () => {
          this.$loading(false)
          this.isLoginCode = true
        },
        (err) => {
          console.log(err)
          this.$loading(false)
          this.$toast(err)
        }
      )
    },
    onLogin(code) {
      this.$loading(true)
      this.$post(
        LOGIN_EMAIL,
        {
          email: this.email,
          verifyCode: code
        },
        (res) => {
          this.$loading(false)
          if (res.token) {
            this.$store.commit("token", res.token)
            this.loadUser()
          } else {
            this.$toast(this.i18n.msg_fail_login)
          }
        },
        (err) => {
          console.log(err)
          this.$loading(false)
          this.$toast(err)
        }
      )
    },
    onAgain() {
      this.isLoginCode = false
      this.onSendMailCode()
    },
    onBackCode() {
      this.isLoginCode = false
    },
    loadUser() {
      this.$loading(true)
      this.$get(
        USER_INFO,
        {},
        (res) => {
          this.$loading(false)
          if (res.user) {
            this.$store.commit("user", res.user)
            this.$toast(this.i18n.msg_success_login)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user
            })
              .then(() => {
                this.loadUser()
              })
              .catch(() => {
                this.$store.commit("token", null)
              })
          }
        },
        (err) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: err,
            showCancel: false
          }).then(() => {
            this.$store.commit("token", null)
          })
        }
      )
    }
  }
}
</script>

<style lang="less">
.login-email-warp {
  padding: 0 56px;
  min-height: calc(100vh - 150px);
  display: flex;
  flex-direction: column;

  // 对齐 App login_email：内容区标题 textColor 26.sp
  .page-title {
    padding: 157px 0 38px;
    font-size: 45px;
    color: var(--text-main);
  }

  .login-row {
    height: 105px;
    display: flex;
    align-items: center;
    // 对齐 App login_email：itemColor 背景 + 圆角 14.w
    background: var(--item-bg);
    border-radius: 24px;
    padding: 0 20px;
    box-sizing: border-box;

    input {
      font-size: 35px;
      flex: 1;
      height: 80px;
      padding: 0 10px;
      margin: 0;
      border: none;
      outline: none;
      background-color: rgba(0, 0, 0, 0);
      color: var(--text-main);

      // 对齐 App：hint 为 textColor 60% 透明度
      &::placeholder {
        color: var(--text-sub);
      }
    }
  }

  // 对齐 App：输入框与按钮之间弹性空间（Expanded）
  .login-spacer {
    flex: 1;
  }

  .btn {
    margin: 60px 0 0;
  }

  // 对齐 App _loginOtherWidget：分割线 + 第三方图标
  .login-foot {
    margin-top: 60px;

    &-tips {
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        // 对齐 App login_other：分割文字 color_fillColor(#000)
        color: var(--text-main);
        font-size: 28px;
        padding: 0 24px;
      }

      &::after,
      &::before {
        content: " ";
        flex: 1;
        height: 1px;
        // 对齐 App login_other：分割线 color_fillColor(#000)
        background-color: var(--text-main);
      }
    }

    &-imgs {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 24px;
      margin-top: 30px;

      // 不限制图标尺寸，原始图片大小显示
      img {
        max-width: 60px;
        height: auto;
      }
    }

    &-gap {
      height: 56px;
    }
  }
}
</style>
